export default __webpack_public_path__ + "static/media/red top hat.b23db370.png";